import { render } from "./ProjectPreparationLoader.vue?vue&type=template&id=2bb9114e"
import script from "./ProjectPreparationLoader.vue?vue&type=script&lang=js"
export * from "./ProjectPreparationLoader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ProjectPreparationLoader.vue?vue&type=style&index=0&id=2bb9114e&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__